<form (ngSubmit)="addRow()" class="addRowForm drop-padding" [formGroup]="createForm">
  <mat-form-field appearance="outline">
    <mat-label>Описание</mat-label>
    <input matInput type="text" formControlName="description" />
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Значение</mat-label>
    <input matInput type="text" formControlName="value" />
  </mat-form-field>
  <button type="submit" mat-flat-button color="primary" [disabled]="loading">
    {{ loading ? 'Загрузка...' : 'Сохранить' }}
  </button>
</form>
